import { backendAuthType } from './constants';
import { customOidcEnabled } from './constants';

export const isSelfHosted = backendAuthType !== 'supabase';
export const isSelfHostedSSO = isSelfHosted && customOidcEnabled;
